/**
 * The storefronts that publish the support phone number. Every other market
 * gets the e-mail address only — on the contact page and in the Organization
 * JSON-LD alike, so search engines are not handed a number the page hides.
 */
export const SUPPORT_PHONE_LOCALES: readonly string[] = ['cs', 'sk']
